// ResourceTagCheckboxes.jsx
import React from "react";
import { useTranslation } from "../../i18n/LanguageProvider";

export default function ResourceTagCheckboxes({
  allTags,
  selectedTags,
  activeTags,
  onTagChange,
}) {
  const { t } = useTranslation();
  return (
    <fieldset className="mb-3 d-flex flex-wrap justify-content-center border-0 p-0">
      <legend className="visually-hidden">{t('resources.filterByTag')}</legend>
      {allTags.map((tag) => {
        const isSelected = selectedTags.includes(tag);
        // If the tag isn’t selected but isn’t present in any filtered resource, disable it.
        const isAvailable = activeTags.includes(tag);
        const disabled = !isSelected && !isAvailable;
        const id = `resource-tag-${tag.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

        return (
          <div key={tag} className="form-check me-3 mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id={id}
              value={tag}
              checked={isSelected}
              disabled={disabled}
              aria-disabled={disabled}
              onChange={() => onTagChange(tag)}
            />
            <label
              className={`form-check-label ${
                tag === "NEW" ? "text-success fw-bold" : ""
              } ${disabled ? "text-muted" : ""}`}
              htmlFor={id}
              style={disabled ? { cursor: "not-allowed" } : { cursor: "pointer" }}
            >
              {tag}
            </label>
          </div>
        );
      })}
    </fieldset>
  );
}
